import apiFetch, { defaultApiFetchErrorHandler } from '@scale/frontend-lib/api-fetch';
import { IUserJson } from '@scale/shared/types/user';

interface SelectOption {
  label: string;
  value: string;
}

export async function fetchUsersWithRole(corpRole?: SelectOption): Promise<SelectOption[]> {
  if (!corpRole) return [];
  try {
    const { users } = await apiFetch(
      null,
      `corp-api/find/corppermissionroles/users?corpRoleId=${corpRole.value}`,
    );
    return users.map((user: IUserJson) => ({
      label: user.email,
      value: user.id,
    }));
  } catch (error) {
    defaultApiFetchErrorHandler(error, { handleHttp: true });
  }
  return [];
}
